module.exports = __webpack_public_path__ + "static/media/subGoogle2.d384a76b.png";